export default "__VITE_ASSET__CUOY4ORS__"